import { Observer } from 'mobx-react-lite';
import React from 'react';
import ReactDOM from 'react-dom';
import './App.scss';
import Symbols from './components/Symbols/Symbols';
import SearchApplet from './components/SearchApplet/SearchApplet';
import { useRootController } from './hooks/controller.hooks';
import { useStore } from './utils/mobx.utils';
var App = function (props) {
    var ROOT = useRootController();
    var s = useStore(function () { return ({
        searchAppletPortalPageSection: document.querySelector('[data-react-portal="search-applet-page-section"]'),
        searchAppletPortalMenu: document.querySelector('[data-react-portal="search-applet-menu"]'),
        searchAppletPortalTagSidebar: document.querySelector('[data-react-portal="search-applet-tag-sidebar"]'),
        searchAppletPortalSearchSidebar: document.querySelector('[data-react-portal="search-applet-search-sidebar"]'),
    }); });
    return React.createElement(Observer, { children: function () { return (ROOT.$ready ? React.createElement("div", { className: "App" },
            React.createElement(Symbols, null),
            s.searchAppletPortalPageSection && ReactDOM.createPortal(React.createElement(SearchApplet, { placeholder: "Search for services or articles" }), s.searchAppletPortalPageSection),
            s.searchAppletPortalMenu && ReactDOM.createPortal(React.createElement(SearchApplet, { placeholder: "Search for services or articles" }), s.searchAppletPortalMenu),
            s.searchAppletPortalTagSidebar && ReactDOM.createPortal(React.createElement(SearchApplet, { placeholder: "Search for services or articles" }), s.searchAppletPortalTagSidebar),
            s.searchAppletPortalSearchSidebar && ReactDOM.createPortal(React.createElement(SearchApplet, { placeholder: "Search for services or articles" }), s.searchAppletPortalSearchSidebar)) : null); } });
};
export default App;
